'use strict';

angular.module('TurneroApp').component('coRoles', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'rolesService',
        'utilsService',
		  'TurneroAppConstant',
        function (rolesService, utilsService, TurneroAppConstant) {
            var ctrl = this;
            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.rolCrear = false;
            ctrl.rolModificar = false;
            ctrl.rolConsultar = true;
            ctrl.rolVer = false; // variable para determinar el comportamiento detalle/edicion
            ctrl.focusBuscar = false;
            ctrl.filter = false;

            ctrl.$onChanges = function () {
                ctrl.grillaReload();
            };

            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.removeFilter = function () {
                ctrl.query.filter = '';
                ctrl.grillaReload();
                ctrl.filter = false;
            };

            ctrl.mostrarBuscar = function () {
                ctrl.filter = true;
                ctrl.focusBuscar = true;
            };

            ctrl.limpiarMemoria = function () {
                ctrl.rolCrear = false;
                ctrl.rolModificar = false;
                ctrl.rolConsultar = false;
                ctrl.rolVer = false;
            }

            ctrl.grillaReload = function () {
                ctrl.limpiarMemoria()
                ctrl.rolConsultar = true;

                if (ctrl.query.filter.length > 2 || ctrl.query.filter.length == 0) {
                    ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos)
                }
            };

            ctrl.getData = function (page, limit, tipo, callback) {
                ctrl.promise = rolesService.Get_Listado({
                    'filtro.nro_Pagina': page,
                    'filtro.tam_Pagina': limit,
                    'filtro.texto': ctrl.query.filter,
                }).$promise.then(function (res) {
                    callback(tipo, res);
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            }

            function cargarDatos(tipo, data) {
                if (tipo == 'grid') {
                    ctrl.roles = data.Data;
                    ctrl.pagination.total = data.Paging.Reg_Totales;
                } else if (tipo == 'xls') {
                    var arrayObjeto = data.Data;
                    ctrl.arrayExport = [];
                    if (ctrl.centroAtencionSeleccionado.id != null)
                        ctrl.arrayExport[0] = [ctrl.centroAtencionSeleccionado.id, ctrl.centroAtencionSeleccionado.text];
                    else
                        ctrl.arrayExport[0] = ["", "NO HAY CENTRO DE ATENCIÓN SELECCIONADO"];
                    ctrl.arrayExport[1] = ['Id', 'Nombre', 'Descripción', 'Restringido', 'Cantidad de Permisos'];
                    for (var i = 0; i < arrayObjeto.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            arrayObjeto[i].Id_Rol,
                            arrayObjeto[i].N_Rol,
                            arrayObjeto[i].Descripcion,
                            arrayObjeto[i].Restringido == 'S' ? 'Si' : 'No',
                            arrayObjeto[i].Permisos
                        ]
                    }
                    swal.close();
                    ctrl.Excel.down([{
                        name: 'Roles',
                        data: ctrl.arrayExport
                    }]);
                }
            }

            ctrl.eliminarRol = function (item) {
                swal({
                    title: "Eliminar Rol",
                    text: "¿Desea quitar el rol?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#971b2f",
                    confirmButtonText: "Si, eliminarlo!",
                    cancelButtonText: "No, cancelar!"
                }).then(function () {
                    rolesService.delete({ 'id': item.Id_Rol }).$promise.then(function (res) {
                        ctrl.grillaReload();
                        swal("Eliminado!", "El rol ha sido eliminado correctamente.", "success");
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });
                });
            };

            ctrl.crearRol = function () {
                ctrl.limpiarMemoria();
                ctrl.rolCrear = true; //visualiza el div de alta
                ctrl.tLoadAlta();
            };

            ctrl.verRol = function (item) {
                ctrl.limpiarMemoria();
                ctrl.rolVer = true;
                ctrl.tLoadModificar(item);
            };

            ctrl.modificarRol = function (item) {
                ctrl.limpiarMemoria();
                ctrl.rolModificar = true;
                ctrl.tLoadModificar(item);
            };

            //EXPORTAR A EXCEL
            ctrl.isOpen = false;
            ctrl.selectedMode = 'md-fling';
            ctrl.selectedDirection = 'up';
            ctrl.exportar = function (tipo) {

                utilsService.swalTitle('Exportando datos', 'info')
                ctrl.arrayExport = [];
                ctrl.getData(1, ctrl.pagination.total, tipo, cargarDatos);

            }
            ctrl.Excel = {
                down: function () {
                },
            }

        }
    ],
    template: require('./roles.html')
});



// WEBPACK FOOTER //
// ./app/components/roles/rolesComponent.js